import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Lock, ScanLine, MessageCircle, Menu, X, Users, ListOrdered, TrendingUp, Settings, LogOut } from "lucide-react";

const USER_KEY = "ct_login_user";

function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
}

function canOpenPage(user, path) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!Array.isArray(user.pageAccess)) return false;
  return user.pageAccess.includes(path);
}

export default function MobileAppNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = getUser();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  const isAdmin = user.role === "admin";

  const logout = async () => {
    const token = localStorage.getItem("ct_login_token");

    if (token) {
      await fetch("/api/login/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).catch(() => {});
    }

    localStorage.removeItem("ct_login_token");
    localStorage.removeItem("ct_login_user");
    localStorage.removeItem("ct_admin_auth");
    setOpen(false);
    navigate("/login", { replace: true });
  };

  const itemClass = path =>
    location.pathname === path ? "mobile-nav-item active" : "mobile-nav-item";

  return (
    <>
      {open && (
        <div className="mobile-more-panel">
          {isAdmin && <Link to="/admin-dashboard" onClick={() => setOpen(false)}>Admin Dashboard</Link>}
          {canOpenPage(user, "/accounts") && <Link to="/accounts" onClick={() => setOpen(false)}>Accounts</Link>}
          {canOpenPage(user, "/groups") && <Link to="/groups" onClick={() => setOpen(false)}>Groups</Link>}
          {canOpenPage(user, "/orders") && <Link to="/orders" onClick={() => setOpen(false)}>Orders</Link>}
          {canOpenPage(user, "/Positions") && <Link to="/Positions" onClick={() => setOpen(false)}>Positions</Link>}
          {canOpenPage(user, "/nexo") && (
            <Link to="/nexo" onClick={() => setOpen(false)}>
              Nexo
            </Link>
          )}

          {canOpenPage(user, "/bloomberg-watch") && (
            <Link to="/bloomberg-watch" onClick={() => setOpen(false)}>
              BloombergWatch
            </Link>
          )}

          {canOpenPage(user, "/bloomberg-terminal") && (
            <Link to="/bloomberg-terminal" onClick={() => setOpen(false)}>
              Bloomberg Terminal
            </Link>
          )}

          {canOpenPage(user, "/option-decay") && (
            <Link to="/option-decay" onClick={() => setOpen(false)}>
              Option Decay Desk
            </Link>
          )}

          {canOpenPage(user, "/expiry-decay-desk") && (
            <Link to="/expiry-decay-desk" onClick={() => setOpen(false)}>
              Expiry Decay Desk
            </Link>
          )}

          {canOpenPage(user, "/market-reaction") && (
            <Link to="/market-reaction" onClick={() => setOpen(false)}>
              Market Reaction
            </Link>
          )}

          {canOpenPage(user, "/strike-market-reaction") && (
            <Link to="/strike-market-reaction" onClick={() => setOpen(false)}>
              Strike Market Reaction
            </Link>
          )}

          {canOpenPage(user, "/stocks") && (
            <Link to="/stocks" onClick={() => setOpen(false)}>
              Stocks
            </Link>
          )}
          {isAdmin && <Link to="/Monitor" onClick={() => setOpen(false)}>Monitor</Link>}
          <Link
            to="/mobile-scanner"
            onClick={() => setOpen(false)}
            style={{ gap: 8 }}
          >
            <ScanLine size={16} />
            Login Scanner
          </Link>
          <button type="button" onClick={logout}>Logout</button>
        </div>
      )}

      <nav className="mobile-app-nav">
        {canOpenPage(user, "/") && (
          <Link to="/" className={itemClass("/")}>
            <Home size={19} />
            <span>Home</span>
          </Link>
        )}

        {canOpenPage(user, "/x-portal") && (
          <Link to="/x-portal" className={itemClass("/x-portal")}>
            <Lock size={19} />
            <span>Secret</span>
          </Link>
        )}

        {canOpenPage(user, "/nifty-support") && (
          <Link to="/nifty-support" className={itemClass("/nifty-support")}>
            <ScanLine size={19} />
            <span>Scanner</span>
          </Link>
        )}

        {canOpenPage(user, "/nexo") && (
          <Link to="/nexo" className={itemClass("/nexo")}>
            <MessageCircle size={19} />
            <span>Nexo</span>
          </Link>
        )}

        <button type="button" className={open ? "mobile-nav-item active" : "mobile-nav-item"} onClick={() => setOpen(v => !v)}>
          {open ? <X size={19} /> : <Menu size={19} />}
          <span>More</span>
        </button>
      </nav>
    </>
  );
}
